import { render, staticRenderFns } from "./sc-nav.vue?vue&type=template&id=17b9bdbb&scoped=true&"
import script from "./sc-nav.vue?vue&type=script&lang=js&"
export * from "./sc-nav.vue?vue&type=script&lang=js&"
import style0 from "./sc-nav.vue?vue&type=style&index=0&id=17b9bdbb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b9bdbb",
  null
  
)

export default component.exports